module.exports = __webpack_public_path__ + "478b9abe006e8949d90a3772b473db89.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/appstore.png
 ** module id = 1559
 ** module chunks = 0
 **/